import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

document.addEventListener('DOMContentLoaded', function() {
    const button = document.querySelector('.pagetop');
    if (button) {
        button.addEventListener('click', function() {
            gsap.to(window, {
                duration: 0.5,
                scrollTo: {y: 0, autoKill: false}
            });
        });
    }
});

